export const initialReportState = {
  currentTab: 0,
  entityType: '',
  entityAssocationType: '',
  entityMetaList: [],
  entityAssocationTypeMeta: [],
  entityAssociationList: [],
  entitySelectedList: [],
  entityAssociationSelectedList: [],
  filters: [],
};
export const ReportReducer = (state, action) => {
  switch (action.type) {
    case ACTIONLIST.RESET_TO_INIT:
      return { currentTab: 0,
        entityType: '',
        entityAssocationType: '',
        entityMetaList: [],
        entityAssocationTypeMeta: [],
        entityAssociationList: [],
        entitySelectedList: [],
        entityAssociationSelectedList: [],
        filters: [],};
    case ACTIONLIST.UPDATE_TAB:
      return {
        ...state,
        currentTab: action.payload,
      };
    case ACTIONLIST.UPDATE_ENTITY_TYPE:
      return {
        ...state,
        entityType: action.payload,
        entityAssocationType: '',
        entityAssocationTypeMeta: [],
        entityAssociationList: [],
        entitySelectedList: [],
        entityAssociationSelectedList: [],
        filters: [],
      };
    case ACTIONLIST.UPDATE_ENTITY_TYPE_META_LIST:
      return {
        ...state,
        entityMetaList: action.payload,
      };
    case ACTIONLIST.UPDATE_ASSOCATION_TYPE:
      return {
        ...state,
        entityAssocationType: action.payload,
        filters: [],
        entityAssociationSelectedList: [],
      };
    case ACTIONLIST.UPDATE_ASSOCATION_TYPE_META_LIST:
      return {
        ...state,
        entityAssocationTypeMeta: action.payload,
      };
    case ACTIONLIST.UPDATE_ASSOCATION_TYPE_LIST:
      return {
        ...state,
        entityAssociationList: action.payload,
      };
    case ACTIONLIST.UPDATE_ENTITY_SELECTION_LIST:
      return {
        ...state,
        entitySelectedList: action.payload,
      };
    case ACTIONLIST.UPDATE_ASSOCATION_SELECTION_LIST:
      return {
        ...state,
        entityAssociationSelectedList: action.payload,
      };
    case ACTIONLIST.UPDATE_FILTER_LIST:
      return {
        ...state,
        filters: [...state.filters, action.payload],
      };
    case ACTIONLIST.UPDATE_FILTER_LIST_ON_LOAD:
      return {
        ...state,
        filters: action.payload,
      };
    case ACTIONLIST.UPDATE_FILTER_LIST_VALUE:
      state.filters[action.payload.index] = action.payload.value;
      return {
        ...state,
      };
    case ACTIONLIST.UPDATE_FILTER_OPERATOR:
      state.filters[action.payload.index].operator = action.payload.value;
      return {
        ...state,
      };
    case ACTIONLIST.UPDATE_FILTER_JOIN:
      state.filters.forEach((filter) => {
        filter.relation = action.payload.value;
      });
      return {
        ...state,
      };
    case ACTIONLIST.UPDATE_FILTER_STATUS:
      state.filters[action.payload.index].value = action.payload.value;
      return {
        ...state,
      };
    case ACTIONLIST.DELETE_FILTER:
      state.filters = state.filters.filter(
        (item) => item.name != action.payload,
      );
      return {
        ...state,
      };
  }
};
export const ACTIONLIST = {
  RESET_TO_INIT:'RESET_TO_INIT',
  UPDATE_TAB: 'UPDATE_TAB',
  UPDATE_ENTITY_TYPE: 'UPDATE_ENTITY_TYPE',
  UPDATE_ENTITY_SELECTION_LIST: 'UPDATE_ENTITY_SELECTION_LIST',
  UPDATE_ASSOCATION_TYPE: 'UPDATE_ASSOCATION_TYPE',
  UPDATE_ASSOCATION_SELECTION_LIST: 'UPDATE_ASSOCATION_SELECTION_LIST',
  UPDATE_ASSOCATION_TYPE_LIST: 'UPDATE_ASSOCATION_TYPE_LIST',
  UPDATE_ASSOCATION_TYPE_META_LIST: 'UPDATE_ASSOCATION_TYPE_META_LIST',
  UPDATE_ENTITY_TYPE_META_LIST: 'UPDATE_ENTITY_TYPE_META_LIST',
  UPDATE_FILTER_LIST: 'UPDATE_FILTER_LIST',
  UPDATE_FILTER_LIST_VALUE: 'UPDATE_FILTER_LIST_VALUE',
  UPDATE_FILTER_OPERATOR: 'UPDATE_FILTER_OPERATOR',
  UPDATE_FILTER_JOIN: 'UPDATE_FILTER_JOIN',
  UPDATE_FILTER_STATUS: 'UPDATE_FILTER_STATUS',
  DELETE_FILTER: 'DELETE_FILTER',
  UPDATE_FILTER_LIST_ON_LOAD: 'UPDATE_FILTER_LIST_ON_LOAD',
};
